import type { ReactNode } from 'react';
import { C } from '../theme';

/**
 * Responsive shell for the mobile (tenant / owner-phone) surfaces.
 * On a real phone it fills the screen and uses the device's own status bar
 * (notch-safe); on a wide screen it presents as a centered phone-width card.
 * No fake device chrome / status bar.
 */
export function Phone({ children }: { children: ReactNode }) {
  return (
    <div className="mobile-shell" style={{ background: C.bg }}>
      {children}
    </div>
  );
}
